import React from 'react';
import { Card, CardHeader, CardTitle, CardBody, Row, Col } from 'reactstrap';

function HelpNoMatriculado() {
  return (
    <div className='content'>
      <Row>
        <Col>
          <Card className='card-user'>
            <CardHeader>
              <Row>
                <Col sm={8}>
                  <CardTitle tag='h4'>Ayuda</CardTitle>
                </Col>
                <Col sm={4}></Col>
              </Row>
            </CardHeader>
            <CardBody>
              <Row className="pt-4 pb-4">
                <Col sm={6}>
                  <h5>Solicitud de matriculación</h5>
                  <div className="mb-4 font-weight-bold">
                    <a
                      href="/pdf/sitio_solicitud_de_matriculacion.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                    >Ver Manual</a>
                  </div>
                </Col>
                <Col sm={6}>
                  <h5>Solicitud de rematriculación</h5>
                  <div className="mb-4 font-weight-bold">
                    <a
                      href="/pdf/sitio_solicitud_de_rematriculacion.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                    >Ver Manual</a>
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default HelpNoMatriculado;
